import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=2ec9316f&scoped=true&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=2ec9316f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9316f",
  null
  
)

export default component.exports